import { render } from "./MobileSetupSideBar.vue?vue&type=template&id=dd8ef668&scoped=true"
import script from "./MobileSetupSideBar.vue?vue&type=script&lang=js"
export * from "./MobileSetupSideBar.vue?vue&type=script&lang=js"

import "./MobileSetupSideBar.vue?vue&type=style&index=0&id=dd8ef668&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8ef668"]])

export default __exports__